import { Metric as ApiMetric, MetricKey } from '../Models/ApiTopFiveMetrics';
import { Metric, MetricType } from '../Models/TopFiveMetrics';
import { getSign } from './getSign';

const MetricKeyToMetricType: Record<MetricKey, MetricType> = {
  average_reviewer_latency_hours: MetricType.AVERAGE_REVIEWER_LATENCY_HOURS,
  average_inline_comments: MetricType.AVERAGE_INLINE_COMMENTS,
  average_defects: MetricType.AVERAGE_DEFECTS,
  average_comments_per_review: MetricType.AVERAGE_COMMENTS_PER_REVIEW,
  average_review_lifecycle_hours: MetricType.AVERAGE_REVIEW_LIFECYCLE_HOURS,
  average_line_counts_per_review: MetricType.AVERAGE_LINE_COUNTS_PER_REVIEW,
  average_test_line_counts_per_review:
    MetricType.AVERAGE_TEST_LINE_COUNTS_PER_REVIEW,
  defect_rate: MetricType.DEFECT_RATE,
  percent_test_lines_per_review: MetricType.PERCENT_TEST_LINES_PER_REVIEW,
  total_code_reviews_completed: MetricType.TOTAL_CODE_REVIEWS_COMPLETED,
  total_inline_comments: MetricType.TOTAL_INLINE_COMMENTS,
  total_defects: MetricType.TOTAL_DEFECTS,
  total_comments: MetricType.TOTAL_COMMENTS,
  total_line_counts: MetricType.TOTAL_LINE_COUNTS,
  total_test_line_counts: MetricType.TOTAL_TEST_LINE_COUNTS,
  total_additions: MetricType.TOTAL_ADDITIONS,
  total_deletions: MetricType.TOTAL_DELETIONS,
};

export function getMetricFromEntry(entry: ApiMetric): Metric {
  const {
    metric_meta,
    improvement,
    abs_change_percent,
    previous,
    current,
    metric_key,
  } = entry;

  const isIncreaseBeneficial = metric_meta.positive_direction === 'up';
  const sign = getSign({ improvement, isIncreaseBeneficial });

  return {
    isIncreaseBeneficial,
    percentageChange: abs_change_percent * sign,
    previousValue: previous,
    currentValue: current,
    type: MetricKeyToMetricType[metric_key],
  };
}
